import React, { useCallback } from "react";
import {
  Grid,
  Typography,
  Container,
  Button,
  Stack
} from "@mui/material";
import Particles from "react-particles";
import { loadFull } from "tsparticles";
import { loadConfettiPreset } from "tsparticles-preset-confetti";
import { loadHeartShape } from "tsparticles-shape-heart";
import { loadFireworksPreset } from "tsparticles-preset-fireworks";
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useSelector } from "react-redux";

import { CONFETTI_OPTIONS, FIREWORKS_OPTIONS, HEART_OPTIONS } from "./particleOptions";


const Complete = ({ activeStep, onhandleBack }) => {
  const { bookFormTheme, thankyouTitle, thankyouMessage, whatsnextMessage, displayConfetti } = useSelector(state => ({
    bookFormTheme: state.book.emailNotification.bookFormTheme,
    thankyouTitle: state.book.emailNotification.thankyouTitle,
    thankyouMessage: state.book.emailNotification.thankyouMessage,
    whatsnextMessage: state.book.emailNotification.whatsnextMessage,
    displayConfetti: state.book.emailNotification.displayConfetti
  }));

  const particlesInit = useCallback(async engine => {
    // console.log(engine);
    // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
    // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
    // starting from v2 you can add only the features you need reducing the bundle size

    await loadFull(engine);
    if (displayConfetti === 'Classic') {
      await loadConfettiPreset(engine);
    } else if (displayConfetti === 'Hearts') {
      await loadHeartShape(engine);
    } else if (displayConfetti === 'Fireworks') {
      await loadFireworksPreset(engine);
    }
  }, []);

  const particlesLoaded = useCallback(async container => {
    // console.log(container);
  }, []);

  function getParticleOptions() {
    if (displayConfetti === 'Classic') {
      return CONFETTI_OPTIONS;
    } else if (displayConfetti === 'Hearts') {
      return HEART_OPTIONS;
    } else if (displayConfetti === 'Fireworks') {
      return FIREWORKS_OPTIONS;
    }
    return {};
  }

  const onCloseWindow = () => {
    window.close();
  };

  return (
    <Grid
      item
      display='flex'
      alignItems='center'
      justifyContent='center'
      sx={{ flexGrow: 1, flexDirection: 'column', paddingY: '5rem', backgroundColor: bookFormTheme ? '#fff' : '#151521' }}
    >
      <Container sx={{ maxWidth: { md: '650px' }, paddingX: '3rem !important' }}>
        <Grid>
          <Typography sx={{ fontSize: '1.4rem', fontWeight: 700, color: bookFormTheme ? '#3f4254' : '#fff' }}>{thankyouTitle}</Typography>
          <Typography sx={{ fontSize: '0.92rem', fontWeight: 300, color: bookFormTheme ? '#333' : '#6D6D80', mt: 1 }}>{thankyouMessage}</Typography>
        </Grid>
        <Stack direction='row' sx={{ backgroundColor: bookFormTheme ? '#E8FFF3' : '#1C3238', padding: '20px', borderRadius: '0.5rem', border: '1px dashed #50cd89', mt: 3 }}>
          <Grid item>
            <ErrorOutlineIcon sx={{ fontSize: '2.5rem', color: '#50cd89' }} />
          </Grid>
          <Grid item sx={{ marginInlineStart: 2 }}>
            <Typography sx={{ fontWeight: 700, color: bookFormTheme ? '#3f4254' : '#fff' }}>What To Expect Next?</Typography>
            <Typography sx={{ fontWeight: 400, fontSize: '14px', color: bookFormTheme ? '#454545' : '#92929f', mt: 1 }}>{whatsnextMessage}</Typography>
          </Grid>
        </Stack>
        <Button
          variant="contained"
          onClick={onCloseWindow}
          sx={{ mt: 3, color: '#fff', fontWeight: 500, padding: '10px 30px', textTransform: 'none' }}
        >
          Close Window
        </Button>
      </Container>
      <Particles
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={getParticleOptions()}
      />
      {/* <Grid display='flex' justifyContent='space-between' sx={{ my: 2, width: { md: '600px' } }}>
        <Button
          variant="contained"
          disabled={activeStep === 0}
          onClick={onhandleBack}
          startIcon={<ArrowBackIcon />}
          sx={{ mt: 1, mr: 1, visibility: activeStep !== 0 ? 'inherit' : 'hidden', color: '#fff', fontWeight: 600, textTransform: 'none' }}
        >
          Back
        </Button>
      </Grid> */}
    </Grid>
  )
}

export default Complete;
